var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EventsView',{class:_vm.$mq !== 'sm' && 'mt-d2',attrs:{"events":_vm.events,"depressed":""}})}
var staticRenderFns = []

export { render, staticRenderFns }